"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorageHcSessionDataProvider = exports.hcSessionContextProvider = void 0;
const hc_session_global_context_generators_1 = require("./hc-session-global-context-generators");
const localStorageHcSessionDataProvider = {
    readHcSessionContextData: () => {
        try {
            const hcData = JSON.parse(window.localStorage.getItem('hc') || 'null');
            return {
                userId: hcData.healthcareUserId?.toString() || null,
                sessionId: hcData.healthcareSession?.toString() || null,
            };
        }
        catch (error) {
            return {
                userId: null,
                sessionId: null,
            };
        }
    },
};
exports.localStorageHcSessionDataProvider = localStorageHcSessionDataProvider;
function hcSessionContextProvider(dataProvider) {
    return [
        (0, hc_session_global_context_generators_1.hcSessionContextFilter)(dataProvider),
        (0, hc_session_global_context_generators_1.hcSessionContextGenerator)(dataProvider),
    ];
}
exports.hcSessionContextProvider = hcSessionContextProvider;
//# sourceMappingURL=hc-session-global-context.js.map